import { z } from 'zod'

export const AccountHealthApiSchemas = {
  listSuspectedFbPolicyOffenders: {
    path: z.undefined(),
    query: z.undefined(),
    request: z.undefined(),
    response: z.object({
      list: z.object({
        flows: z.array(
          z.object({
            ns: z.string(),
            name: z.string(),
            has_message_tag: z.boolean(),
            has_otn_reason: z.boolean(),
            ts_updated: z.number(),
          }),
        ),
        broadcasts: z.array(z.unknown()),
      }),
    }),
  },
}
